export const saleType = {
  RENEWAL: 'RENEWAL',
  UPGRADE: 'UPGRADE',
  NEW: 'NEW',
};
